export default __webpack_public_path__ + "static/media/logo-dark.c29af9dc.svg";